import { useState } from "react";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "./ui/dialog";

export default function IntakeBatchDialog({ open, onOpenChange, onCreate }) {
  const [name, setName] = useState("");
  const [purchaseReference, setPurchaseReference] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    setSaving(true);
    try {
      await onCreate({
        name: name.trim() || "Manual intake",
        purchase_reference: purchaseReference.trim() || null,
      });
      setName("");
      setPurchaseReference("");
      onOpenChange(false);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="workspace-dialog" data-testid="intake-batch-dialog">
        <DialogHeader>
          <DialogTitle>Start intake batch</DialogTitle>
          <DialogDescription>
            Group cards from one acquisition before they enter inventory.
          </DialogDescription>
        </DialogHeader>
        <form className="workspace-form" onSubmit={submit} data-testid="intake-batch-form">
          <label>
            <span>Batch name</span>
            <input
              value={name}
              onChange={(event) => setName(event.target.value)}
              placeholder="Weekend card show"
              data-testid="intake-batch-name-input"
            />
          </label>
          <label>
            <span>Purchase reference</span>
            <input
              value={purchaseReference}
              onChange={(event) => setPurchaseReference(event.target.value)}
              placeholder="Receipt, seller, or invoice"
              data-testid="intake-batch-reference-input"
            />
          </label>
          <button
            className="admin-primary-button"
            disabled={saving}
            type="submit"
            data-testid="create-intake-batch-button"
          >
            {saving ? "Creating…" : "Create batch"}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
}